import React from "react";
import { Children, ReactNode, cloneElement } from "react";

import { css } from "@emotion/core";

type AsyncOverlayProps = {
  children: React.ReactElement;
  /** Is indicator visible */
  isVisible?: boolean;
  /** Used to render a custom Indicator */
  renderAsyncIndicator: () => ReactNode;
};

const overlayCss = css`
  align-items: center;
  background-color: rgba(255, 253, 249, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 901;
`;

/**
 * Renders a loading indicator on top of children content
 */
export const AsyncOverlay = ({
  children,
  isVisible = false,
  renderAsyncIndicator,
}: AsyncOverlayProps) => {
  const childrenProps = children?.props ?? {};
  const childrenStyle = childrenProps?.style ?? {};

  // Clone the child and set it's position to relative if needed.
  // This allows the overlay to seamlessly cover the whole
  // area of the child.
  return cloneElement(
    children,
    {
      ...childrenProps,
      style: {
        ...childrenStyle,
        position: childrenStyle?.position ?? "relative",
      },
    },
    [
      ...Children.toArray(children?.props?.children),
      isVisible && (
        <div css={overlayCss} key="indicator">
          {renderAsyncIndicator()}
        </div>
      ),
    ]
  );
};
